import React from 'react';
import TWBadge from './tailwindBadge';

export default ({
	status,
	children,
	border,
	ghost,
	hasDot,
	size,
	className,
	isBeta,
	onClick,
}) => {
	return (
		<TWBadge
			status={status}
			noBackground={ghost}
			hasDot={hasDot}
			size={size}
			className={className}
			border={border}
			isBeta={isBeta}
			onClick={onClick}
		>
			{children}
		</TWBadge>
	);
};
